import { cn } from '@/lib/utils'

// Pill colours come from the --status-* token pairs in index.css. Status is
// conventional (blue neutral, amber attention, green good, red problem) and
// never uses the brand burgundy, which is identity only.
const STATUS_CONFIG: Record<
  string,
  { label: string; className: string }
> = {
  DRAFT: {
    label: 'Draft',
    className: 'bg-[var(--status-draft-bg)] text-[var(--status-draft-fg)]',
  },
  AWAITING_APPROVAL: {
    label: 'Awaiting approval',
    className: 'bg-[var(--status-awaiting-bg)] text-[var(--status-awaiting-fg)]',
  },
  APPROVED: {
    label: 'Approved',
    className: 'bg-[var(--status-approved-bg)] text-[var(--status-approved-fg)]',
  },
  ORDERED: {
    label: 'Ordered',
    className: 'bg-[var(--status-ordered-bg)] text-[var(--status-ordered-fg)]',
  },
  PARTIAL_ORDERED: {
    label: 'Partial ordered',
    className: 'bg-[var(--status-partial-bg)] text-[var(--status-partial-fg)]',
  },
  ARCHIVED: {
    label: 'Archived',
    className: 'bg-[var(--status-archived-bg)] text-[var(--status-archived-fg)]',
  },
  REJECTED: {
    label: 'Rejected',
    className: 'bg-[var(--status-rejected-bg)] text-[var(--status-rejected-fg)]',
  },
}

const BASE =
  'inline-block rounded-full text-[10.5px] font-semibold px-2 py-0.5 leading-none'

interface StatusBadgeProps {
  status: string
  className?: string
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? {
    label: status,
    className: STATUS_CONFIG.ARCHIVED.className,
  }

  return (
    <span
      className={cn(BASE, config.className, className)}
      data-status={status}
    >
      {config.label}
    </span>
  )
}
